import "@/App.css";
import { BookingProvider } from "@/context/BookingContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SplitScreen from "@/components/SplitScreen";
import Services from "@/components/Services";
import Marquee from "@/components/Marquee";
import Lookbook from "@/components/Lookbook";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BookingDrawer from "@/components/BookingDrawer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <BookingProvider>
        <Navbar />
        <main>
          <Hero />
          <SplitScreen />
          <Services />
          <Marquee />
          <Lookbook />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <BookingDrawer />
        <Toaster />
      </BookingProvider>
    </div>
  );
}

export default App;
